/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading components
 * -----------------------------------------------------------------------------------------------------------
 */
import auth from 'src/router/auth'
import SalerConfig from '../SalerConfig'
import SalerConfigByUser from '../SalerConfigByUser'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Define component
 * -----------------------------------------------------------------------------------------------------------
 */
export default [
  {
    path: '/settings/saller',
    name: 'saller-config',
    component: SalerConfig,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/settings/saller-by-saler/:id',
    name: 'saller-config-by-saler',
    component: SalerConfigByUser,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/salerConfig/routes/index.js